import { render, staticRenderFns } from "./ViewerPanelComments.vue?vue&type=template&id=391a4724&scoped=true"
import script from "./ViewerPanelComments.vue?vue&type=script&lang=js"
export * from "./ViewerPanelComments.vue?vue&type=script&lang=js"
import style0 from "./ViewerPanelComments.vue?vue&type=style&index=0&id=391a4724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a4724",
  null
  
)

export default component.exports